module.exports = __webpack_public_path__ + "static/img/logo.8dfb71c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/area/logo.png
// module id = Kv9p
// module chunks = 1